<template>
    <span class="loading-container" :class="{ 'mini': mini, 'alt': alt, 'inline': inline, 'relative': relative }">
        <span class="loader-spinner">Laden...</span>
    </span>
</template>


<script>
export default {
    name: 'Spinner',
    props: {
        mini: {
            type: Boolean,
            default: false
        },
        alt: {
            type: Boolean,
            default: false
        },
        relative: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            default: false,
        }
    }
}
</script>


<style lang="scss">

    @import 'global';
    .loading-container {

        &.page-view {
            min-height: 100vh;
            display: block;
        }

        $spinner-color: $color-blue;
        $spinner-color-secondary: transparentize($spinner-color, 0.8);
        $spinner-border-size: 3px;
        $spinner-size: 30px;
        $spinner-mini-size: 16px;
        $spinner-mini-border-size: 1px;

        .loader-spinner {

            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: -0.5*$spinner-size 0 0 -0.5*$spinner-size;

            box-sizing: content-box;
            width: $spinner-size;
            padding-top: $spinner-size;
            height: 0;
            overflow: hidden;

            border-radius: 50%;

            border-top: $spinner-border-size solid $spinner-color-secondary;
            border-right: $spinner-border-size solid $spinner-color-secondary;
            border-bottom: $spinner-border-size solid $spinner-color-secondary;
            border-left: $spinner-border-size solid $spinner-color;

            transform: translateZ(0);
            animation: fade-in 0.7s linear forwards, spin 0.4s linear infinite;

        }

        &.mini {
            .loader-spinner {
                margin: -0.5*$spinner-mini-size 0 0 -0.5*$spinner-mini-size;
                width: $spinner-mini-size;
                padding-top: $spinner-mini-size;
                border-width: $spinner-mini-border-size;
            }
        }

        &.alt {
            $spinner-color-alt: transparentize($color-white, 0.8);
            .loader-spinner {
                border-top-color: $color-white;
                border-right-color: $spinner-color-alt;
                border-bottom-color: $spinner-color-alt;
                border-left-color: $spinner-color-alt;
            }
        }

        &.inline {
            vertical-align: middle;
            .loader-spinner {
                display: inline-block;
                position: static;
                margin: 0 0.2em;
                vertical-align: middle;
            }
        }

        &.relative {
          display: block;
          position: relative;
          height: $spinner-size;
          margin-top: $spinner-size;
          margin-bottom: $spinner-size;
        }

        .primary-button & {
            position: absolute;

            // offsets for bottom and right button asset
            top: -3px;
            left: 4px;

            width: 100%;
            height: 100%;
        }
    }


    @keyframes spin {
        0% { transform: rotate(0deg) }
        100% { transform: rotate(360deg) }
    }

    @keyframes fade-in {
        0% { opacity: 0 }
        100% { opacity: 1 }
    }

</style>



// WEBPACK FOOTER //
// Loading.vue?8c7f3fea